<template>
    <div
        class="dk-wizard-lead-form-modal-color-selection"
        :class="{
            'lg:tw-mr-6': colors.length > 9 && !showLess && !hasScroll,
            'lg:tw-mr-4': (colors.length > 9 && showLess && !hasScroll) || hasScroll,
        }"
    >
        <dk-wizard-lead-form-car-image v-if="imageSrc" :image="imageSrc" :full-name="fullName" />
        <div class="dk-wizard-lead-form-modal-color-selection__colors tw-mt-8 lg:tw-mt-6 tw-text-center">
            <h6
                class="dk-wizard-lead-form-modal-color-selection__colors-title tw-text-2xl tw-leading-lg tw-font-semibold tw-text-center"
            >
                {{ $t('configure-car.select-color') }}
            </h6>
            <dk-color-picker
                v-if="colors.length"
                class="dk-wizard-lead-form-modal-color-selection__colors-picker tw-mt-6 lg:tw-mt-4"
                size="s"
                :colors="colors"
                :max-landing="maxColors"
                :show-color-name="false"
                :disclaimer="$t('configure-car.disclaimer')"
                has-dealer-selection-layout
                is-inside-modal
                @item-click="onColorSelect"
                @show-less="toggleShowLess"
            />
            <div v-else class="dk-wizard-lead-form-modal-color-selection__basic-colors tw-mt-6 lg:tw-mt-4">
                <div
                    class="dk-wizard-lead-form-modal-color-selection__basic-colors-list tw-grid tw-grid-cols-3 tw-gap-y-4 max-lg:tw-px-4 lg:tw-flex lg:tw-items-center lg:tw-justify-center lg:tw-flex-wrap lg:tw-gap-10"
                >
                    <label v-for="(color, i) in fakeColors" :key="i" class="tw-inline-flex tw-items-center tw-gap-2">
                        <input
                            v-model="smokeColor"
                            class="!tw-m-0"
                            type="radio"
                            name="smoke-color"
                            :value="$t(`configure-car.smoke-color.${color}`)"
                            @change="onFakeColorSelection"
                        >
                        <span class="tw-text-base tw-leading-sm tw-text-basic">
                            {{ $t(`configure-car.smoke-color.${color}`) }}
                        </span>
                    </label>
                </div>
                <p
                    class="dk-wizard-lead-form-modal-color-selection__basic-colors-disclaimer tw-mt-4 micro tw-text-base-subtle"
                >
                    {{ $t('configure-car.disclaimer') }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import gaEventHandler from '@v4/common/components/mixins/google-analytics';

export default {
    name: 'DkWizardLeadFormColorSelection',
    components: {
        DkColorPicker: () => ({
            component: import(
                /* webpackChunkName: "ColorSelector-vue" */ '@v4/common/components/molecules/DkColorPicker.vue'
            ),
        }),
        DkWizardLeadFormCarImage: () => ({
            component: import(
                /* webpackChunkName: "ColorSelector-vue" */ '@v4/common/components/organisms/DkWizardLeadFormModal/components/DkWizardLeadFormCarImage.vue'
            ),
        }),
    },
    mixins: [gaEventHandler],
    props: {
        colors: {
            type: Array,
            required: true,
        },
        defaultColor: {
            type: Object,
            default: () => ({}),
        },
        image: {
            type: String,
            default: '',
        },
        maxColors: {
            type: Number,
            default: 5,
        },
        fullName: {
            type: String,
            default: '',
        },
        hasScroll: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            fakeColors: ['black', 'white', 'red', 'gray', 'blue', 'others'],
            loading: false,
            error: null,
            activeColor: this.defaultColor,
            smokeColor: '',
            colorsMaxItem: 4,
            colorsList: this.colors,
            showLess: false,
        };
    },
    computed: {
        imageSrc() {
            return (
                (this.activeColor && this.activeColor.colorImage && this.activeColor.colorImage.image800) ||
                this.image ||
                ''
            );
        },
    },
    methods: {
        onColorSelect(index = 0) {
            const colors = this.colorsList;
            if (!colors[index]) {
                return;
            }

            this.colorsList = colors.map((item, i) => {
                if (i === index) {
                    item.active = true;
                } else {
                    item.active = false;
                }
                return item;
            });

            this.activeColor = colors[index];
            this.$emit('color-change', this.activeColor);
        },
        onFakeColorSelection() {
            this.$emit('fake-color-select', this.smokeColor);
        },
        toggleShowLess(isShowLessActive) {
            this.showLess = isShowLessActive;
        },
    },
};
</script>
